/**
 * This is the single source of truth for embedded API events
 * Each event is assigned an object consisting of two properties
 * @property {string} name - the name of the embedded event
 * @property {array of strings} requiredFields- the name of the properties that must be specified
 * when posting the event
 */

const sharedEvents = {
    prospectSignupComplete: {
        name: "prospectSignupComplete",
    },
    messageSent: {
        name: "messageSent",
    },
};

export default sharedEvents;
